import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Auth } from 'aws-amplify';
import { NavController } from '@ionic/angular';
import { COUNTRIES } from '../shared/constants/countries';
import { AuthService } from '../shared/services/auth_service';
import { HelperService } from '../shared/services/helper_service';
import { CognitoHostedUIIdentityProvider } from "@aws-amplify/auth/lib/types";
import { environment } from '../../environments/environment';
import { FCM } from 'plugins/cordova-plugin-fcm-with-dependecy-updated/ionic/ngx/FCM';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Meta } from '@angular/platform-browser';
import {DomSanitizer} from '@angular/platform-browser';

interface Country {
  name: string
  phoneCountryCode: string;
  file_url: string;
};
@Component({
  selector: 'app-signuppage',
  templateUrl: './signuppage.page.html',
  styleUrls: ['./signuppage.page.scss'],
})

export class SignupPage implements OnInit {

  public env = environment;
  hrefLink = "https://namma11-dev.auth.ap-south-1.amazoncognito.com/login?response_type=code&client_id=1h877jduk7pdn58jsa1g2rpds5&redirect_uri=http://localhost:8100/signup/"
  Namma11CupLogo = '/mobile/logos/appcuplogo.png';
  countries: Country[] = COUNTRIES;
  countryCode: string;
  countryValue: string;
  language: string;
  phoneNumber: string;
  isSubmitted = false;
  phoneCode: string;
  logindata: FormGroup;
  appVersion: string;
  fcmToken: string;
  selectedlang : any;
  errormsg :string;
  cacheCleartimestamp : number = new Date().getTime();
  myLink: any = "/";
  myMatchId: any = '';
  myContestId: any = '';
  fromTeam: any = '';

  constructor(
    public formBuilder: FormBuilder,
    private translate: TranslateService,
    private router: Router,
    private authService: AuthService,
    private helpService: HelperService,
    //private fcm: FCM,
    private navCtrl: NavController,
    private httpClient: HttpClient,
    public activatedRoute: ActivatedRoute,
    private http : HttpClient,
    private meta: Meta,
    private sanitizer:DomSanitizer
  ) {
    Auth.currentAuthenticatedUser()
      .then((res) => {
        this.navCtrl.navigateBack(['/dashboardpage']);
      })
      .catch((err) => {
        console.log(err);
      });
    activatedRoute.queryParams.subscribe(res => {
      if (res.ref) {
        localStorage.setItem('refCode', res.ref);
      } else {
        localStorage.removeItem('refCode');
      }
    })
    this.logindata = this.formBuilder.group({
      coutrycode: ['', Validators.required],
      phoneno: ['', Validators.required],
    });
  }

  useLanguage(language: string) {
    localStorage.setItem("language", language)
    this.translate.use(language);
    this.selectedlang = language
  }

  ionViewWillEnter() {
    this.cacheCleartimestamp = new Date().getTime();
    this.language = localStorage.getItem("language");
    this.selectedlang = this.language
    if (this.language === 'en') {
      this.translate.use('en');
    }
    else if (this.language === 'hn') {
      this.translate.use('hn');
    }
    else if (this.language === 'kn') {
      this.translate.use('kn');
    }
    const ver = this.meta.getTag('name=version');
    this.appVersion = (localStorage.getItem("app_version") && localStorage.getItem("app_version") != 'null') ? localStorage.getItem("app_version") : (`V. ${ver.content}` || '');
  }
  
  ngOnInit() {
    this.countryValue = '+91';
    // try {
    //   this.getfcmToken();
    // } catch (error) {
    //   console.log(error);
    // }
    // let page = this.activatedRoute.snapshot.paramMap.get('page');
    // console.log('%c page','color:blue', page);
    // if(page){
    //   document.getElementById('goto-link').click();
    // }
    console.log("run ngOnInit");
    this.getDeepLinkData();

  }

  async getDeepLinkData(){
    let page = this.activatedRoute.snapshot.paramMap.get('page');
    this.myMatchId = this.activatedRoute.snapshot.paramMap.get('matchId');
    this.myContestId = this.activatedRoute.snapshot.paramMap.get('contestId');
    this.fromTeam = this.activatedRoute.snapshot.paramMap.get('fromTeam');
    if(page && page == '1'){
        window.location.href = `namma11://${environment.shareurl}/contest-detail/${this.myMatchId}/${this.myContestId}`;
    } else if(page && page == '2'){
        window.location.href = `namma11://${environment.shareurl}/games/pickem-lobbypage/${this.myMatchId}/${this.fromTeam}`;
    } else if(page && page == '3'){
        window.location.href = `namma11://${environment.shareurl}/signup`;
    }
  }

  async loginClick() {
    console.log("phonenumber",this.phoneNumber);
    [this.phoneNumber].forEach(async c =>{
      console.log(c);
      const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~ ]/;
      const StringValidator = specialChars.test(c);
      console.log(StringValidator);
      if(StringValidator){
        this.helpService.presentToast("Please enter a valid number");
      }else if(this.phoneNumber[0] == "9" || this.phoneNumber[0] == "8" || this.phoneNumber[0] == "7" || this.phoneNumber[0] == "6"){
        let phoneNumber = this.countryValue + this.phoneNumber;
        localStorage.setItem("phoneNumber", this.phoneNumber);
        localStorage.setItem("country-code", this.countryValue);
        localStorage.setItem("country_phone", phoneNumber);
        this.helpService.loaderShow();
        try {
          const user = await Auth.signIn(phoneNumber);
          console.log("user=========",user)
          this.authService.isUserLoggedIn = user;
          this.phoneNumber = null;
          this.router.navigate(['/otp']);
          this.helpService.loaderHide();
        } catch (error) {
          if (error.code === "UserNotFoundException") {
            console.log('run');
            this.helpService.loaderHide();
            this.router.navigate(['/referral']);
          }else{
            // console.log("HI");
            this.errormsg = error.message ;
            this.errormsg = this.errormsg.replace("CreateAuthChallenge failed with error ", "");     
            this.helpService.presentToast(this.errormsg);
          }
        }
        this.helpService.loaderHide();

      }else{
        this.helpService.presentToast("Please enter a valid number");
      }
    });

  }
  async callback(){

    // this.phoneNumber.split('').forEach(async function(c) {
    //   console.log(c);
    //   const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~ ]/;
    //  const StringValidator = specialChars.test(c);
    //   console.log(StringValidator);
    //   if(StringValidator){
    //     console.log("Please enter a valid number");
    //     this.helpService.presentToast("Please enter a valid number");
    //   }else{

    //   }
    // });
    // this.helpService.presentToast("Please enter a valid number");
  }

  async googleTrack() {
    await Auth.federatedSignIn({ provider: CognitoHostedUIIdentityProvider.Google });
  }

  async facebookTrack() {
    // await Auth.federatedSignIn({ provider: CognitoHostedUIIdentityProvider.Facebook });
  }

  // getfcmToken() {
  //   this.fcm.getToken().then(token => {
  //     this.fcmToken = token;
  //     let email = localStorage.getItem('user_email');
  //     //console.log(email);
  //     let body = {
  //       email: email,
  //       push_id: this.fcmToken,
  //       enabled: true
  //     }
  //     const headers = new HttpHeaders();
  //     headers.append('Content-Type', 'text/plain');
  //     //console.log(body);
  //     this.httpClient.post('https://namma11mas.intuceo.com/notification/appcallback', body, { headers: headers }).subscribe(data => {
  //       //console.log(data);
  //     });
  //     //console.log(this.fcmToken);
  //   }).catch((error) => {
  //     console.log(error);
  //   });
  // }
}
